import {VideoSettingsLS} from '../modules/video-settings';

export const initialState = {
  videoSettings: VideoSettingsLS.get(),
};
